import { SEO } from "@/components/SEO";
import socialSharingImage from "@/assets/social_sharing.jpg";
import { HeroSection } from "@/components/HeroSection";
import { FeaturedGames } from "@/components/FeaturedGames";
import { PlayerFeatures } from "@/components/PlayerFeatures";
import { HowItWorks } from "@/components/HowItWorks";
import { SEOContent } from "@/components/SEOContent";
import { Footer } from "@/components/Footer";
import { useEffect } from "react";
import { useAuth } from "@/hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { InfoBanners } from "@/components/InfoBanners";

const Index = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user?.id) {
      navigate("/dashboard");
    }
  }, [user?.id, loading, navigate]);

  if (loading) {
    return null;
  }

  return (
    <div className="min-h-screen">
      <SEO
        title="IndieKeys | Platform for Indie Game Keys & Creator Outreach"
        description="IndieKeys connects indie game developers with content creators and players. Promote your games, manage press kits, and grow your studio's visibility. Join the community today!"
        keywords="indie game keys, game key distribution, content creator platform, indie game developers, free game keys, press kit, game marketing, Steam keys, indie games, game promotion"
        image={socialSharingImage}
      >
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "IndieKeys",
            "url": window.location.origin,
            "potentialAction": {
              "@type": "SearchAction",
              "target": `${window.location.origin}/games?search={search_term_string}`,
              "query-input": "required name=search_term_string"
            }
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "IndieKeys",
            "url": window.location.origin,
            "logo": `${window.location.origin}/logo.png`,
            "description": "The ultimate platform for indie game developers and content creators."
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            "name": "IndieKeys",
            "applicationCategory": "BusinessApplication",
            "operatingSystem": "Web",
            "offers": {
              "@type": "Offer",
              "price": "0",
              "priceCurrency": "EUR",
              "description": "Free for all users with optional premium features for developers"
            },
            "description": "IndieKeys is a free platform connecting indie game developers with content creators and players for game key distribution and promotion."
          })}
        </script>
      </SEO>
      <HeroSection />
      <FeaturedGames />
      <PlayerFeatures />
      <HowItWorks />
      <SEOContent />
      <Footer />
    </div>
  );
};

export default Index;
